<template>
    <div class="popover-container">
        <!-- DEMO -->
        <el-popover 
            placement="left-end" 
            popper-class="popover-zdy" 
            trigger="hover">
            <div class="popover-content">
                <!-- ANDROID -->
                <div class="email-tel-area rw-tel-area">
                    <div class="icon-box">
                        <div class="icon-float">
                            <img v-lazy="iconObj.icon_google_play" alt="ICON" />
                        </div>
                        <div class="infos-float">
                            <div class="popover-title rw-text-color" style="display:none;">{{ $t('index.right_pop.download_tips') }}</div>
                            <div class="popover-sub-title rw-text-color1">{{ $t('index.right_pop.download_android') }}</div>
                        </div>
                    </div>

                    <div class="qr-contact-float">
                        <img v-lazy="iconObj.qr_android" alt="ICON" />
                    </div>
                </div>

                <div class="midLine1"></div>

                <!-- IOS -->
                <div class="email-tel-area rw-tel-area">
                    <div class="icon-box">
                        <div class="icon-float">
                            <img v-lazy="iconObj.icon_ios" alt="ICON" />
                        </div>
                        <div class="infos-float">
                            <div class="popover-title rw-text-color" style="display:none;">{{ $t('index.right_pop.download_tips') }}</div>
                            <div class="popover-sub-title rw-text-color1">{{ $t('index.right_pop.download_ios') }}</div>
                        </div>
                    </div>

                    <div class="qr-contact-float">
                        <img v-lazy="iconObj.qr_ios" alt="ICON" />
                    </div>
                </div>
            </div>

            <!-- R-B-DEMO -->
            <el-button slot="reference" class="contact-us-btn bot">
                <div class="fx-col">
                    <img v-lazy="iconObj.float_icon_demo" alt="ICON" />
                    <span>{{ $t('index.right_pop.demo_app') }}</span>
                </div>
            </el-button>
        </el-popover>

        <div class="midLine"></div>

        <!-- CONTACT -->
        <el-popover 
            placement="left-end" 
            popper-class="popover-zdy" 
            trigger="hover">
            <div class="popover-content" v-if="false">
                <!-- EMAIL -->
                <div class="email-tel-area">
                    <div class="icon-float">
                        <img v-lazy="iconObj.icon_email" alt="ICON" />
                    </div>
                    <div class="infos-float">
                        <div class="popover-title">{{ $t('index.right_pop.contact_us_wx_tips') }}</div>
                        <div class="popover-sub-title">
                            <el-tooltip class="item" effect="dark" content="请将#替换为@" placement="top">
                                <span>{{ $t('index.right_pop.contact_us_wx') }}</span>
                            </el-tooltip>
                        </div>
                    </div>
                </div>

                <div class="midLine1"></div>

                <!-- TEL -->
                <div class="email-tel-area rw-tel-area">
                    <div class="icon-box">
                        <div class="icon-float">
                            <img v-lazy="iconObj.icon_tel" alt="ICON" />
                        </div>
                        <div class="infos-float">
                            <div class="popover-title">{{ $t('index.right_pop.contact_us_tel_tips') }}</div>
                            <div class="popover-sub-title"><!--  rw-text-color -->
                                <el-tooltip class="item" effect="dark" content="请将#替换为@" placement="top">
                                    <span>{{ $t('index.right_pop.contact_us_tel') }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>

                    <div class="qr-contact-float">
                        <img v-lazy="iconObj.qr_contact" alt="ICON" />
                    </div>
                </div>
            </div>

            <div class="popover-content1">
                <img :src="newContactCard" alt="Contact Card" />
            </div>

            <!-- R-T-CONTACT -->
            <el-button slot="reference" class="contact-us-btn top">
                <div class="fx-col">
                    <img v-lazy="iconObj.float_icon_chat" alt="ICON" />
                    <span>{{ $t('index.right_pop.contact_us') }}</span>
                </div>
            </el-button>
        </el-popover>
    </div>
</template>

<script>
/**
 * Common Right Contact Us
 */
/* import contactWechatImg  from '@/../public/static/imgs/wechat/summer.png';
import contactDemoAppImg from '@/../public/static/imgs/wechat/demo-app.png'; */

import { mapState }   from 'vuex';
import newContactCard from '@/assets/static/imgs/common/new-contact-card.png';
import { getDemoQrCodeImages } from '@/utils/qrCodeConfig';

export default {
    name: 'CommonRightContactUs',
    data() {
        return {
            // contactWechatImg,
            // contactDemoAppImg,
            // visible: true,
            newContactCard,
            iconObj: {
				icon_email      : require('@/assets/static/imgs/common/icon-email.png'),
				icon_tel        : require('@/assets/static/imgs/common/icon-tel.png'),
				qr_contact      : require('@/assets/static/imgs/common/qr-contact.png'),
				float_icon_chat : require('@/assets/static/imgs/common/float_icon_chat.png'),
				icon_google_play: require('@/assets/static/imgs/common/icon-google-play.png'),
				icon_ios        : require('@/assets/static/imgs/common/icon-ios.png'),
				...getDemoQrCodeImages(),
				float_icon_demo : require('@/assets/static/imgs/common/float_icon_demo.png')
			}
        }
    },
    methods: {
		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
	},
    computed: {
		// ES6展开合并运算符
		...mapState(['isHideForTest'])
	}
}
</script>

<style lang="less" scoped>
.el-popover{
    box-sizing:border-box !important;
    .popover-content{
        width:100%;height:100%;
        display:flex;flex-direction:column;justify-content:space-around;align-items:center;
        /* gap:15px; */
        .email-tel-area{
            width:inherit;
            display:flex;justify-content:flex-start;align-items:center;
            .icon-box{
                display:flex;justify-content:flex-start;align-items:center;
                .icon-float{
                    height:30px;
                    img{
                        width:30px;height:inherit;
                    }
                }
            }
            .infos-float{
                margin-left:10px;
                display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
            }
            .popover-title{
                font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-17);color:var(--com-main-ft-color);font-weight:bold;
            }
            .popover-sub-title{
                font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-17);color:#1D55FF;font-style:italic;
                font-weight:bold;
                span{
                    font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-17);color:#1D55FF;font-style:italic;
                    font-weight:bold;
                }
            }
            .rw-text-color{
                font-style:normal;color:#ADB2BC;
            }
            .rw-text-color1{
                font-style:normal;font-weight:bold;color:var(--com-main-ft-color);
            }
        }
        .rw-tel-area{
            justify-content:space-between;
            .qr-contact-float{
                width:80px;height:80px;
                img{
                    width:inherit;height:inherit;
                }
            }
        }
        .midLine1{
            width:inherit;height:1px;
            border-top:1px solid #F4F3FA;
        }

        .popover-body{
            font-size:var(--com-base-fz-14);color:#333;
            width:180px;height:180px;
            img{
                width:inherit;height:inherit;
            }
        }
    }
    .popover-content1{width:343px;height:428px;}
    .popover-content1 img{
        width:inherit;height:inherit;
        border-radius:12px;
    }
}

.popover-container{
    position:fixed;right:20px;bottom:160px;
    display:flex;flex-direction:column;justify-content:center;align-items:center;
    width:75px;height:178px;padding:0px;
    background:#FFF;box-shadow:0 4px 40px 0 rgba(48, 53, 66, .1);
    border-radius:12px;
    .midLine{
        width:50px;height:1px;
        border-top:1px dotted #F7F7F7;
    }
    button.contact-us-btn{
        border:none;outline:none;
        width:60px;height:87px;
        .fx-col{
            img{width:30px;height:30px;margin-bottom:10px;}
        }
        span{
            font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-12);font-weight:bold;
        }
        &:hover{
            background:#FFF;
            /* i, span{
                color:#8E52E6;
            } */
        }
    }
    button.top{
        border-radius:12px 12px 0 0;
    }
    button.bot{
        border-radius:0 0 12px 12px;
    }
}
</style>
